import BulkInAppNotificationList from './bulkInAppNotificationList';
import BulkInAppNotificationShow from './bulkInAppNotificationShow';
import BulkInAppNotificationCreate from './bulkInAppNotificationCreate';

export default {
    list: BulkInAppNotificationList,
    show: BulkInAppNotificationShow,
    create: BulkInAppNotificationCreate
}